module.exports = __webpack_public_path__ + "media/goforajourney/img/madrid-tour-b5f2273b04cc881fe7394a9cd75b748e.jpg";